export default __webpack_public_path__ + "static/media/streaks 100.897e72df.svg";